import axios from "axios";
import DevSwitch from '../../DevSwitch.js'

export function requestGetEventsIndex() {
  if (DevSwitch == true) {
    return axios.get('data/eventsIndex.json', { 'muteHttpExceptions': true })
  } else {
    return axios.get('https://www.dissidiacompendium.com/data/eventsIndex.json', { 'muteHttpExceptions': true })
  }
}
